// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--1nTpR","onDark":"styles-module--onDark--gjpIe"};